import { Helmet } from "react-helmet-async";
import App from "./App";

const MeritX = () => {
  return (
    <>
      <Helmet title="MeritX Engine" />
      <div id="meritx-root">
        <App />
      </div>
    </>
  );
};

export default MeritX;
